
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBipolar_transistorOn as ObiBipolar_transistorOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-bipolar_transistor-on.js';
 
 
 

 
 export const ObiBipolar_transistorOn = createComponent({
   react: React,
   tagName: 'obi-bipolar_transistor-on',
   elementClass: ObiBipolar_transistorOnElement,
   events: {
     
   }
  });
 
 